import React from 'react';

import styles from './summary-group-base-component.module.scss';

interface OnwProps {
    title: React.ReactNode;
    content: React.ReactNode;
}

type Props = OnwProps;

const SummaryGroupBaseComponent: React.FC<Props> = (props) => {
    const { title, content } = props;

    return (
        <div className={styles.chargeGroup}>
            <div className={styles.chargeGroupTitle}>{title}</div>
            {content}
        </div>
    );
};

export { SummaryGroupBaseComponent };
